import { useState } from "react";
import { Alert, Box, Button, TextField } from "@mui/material";
import { Card, PageHero, Section } from "../components/ui";
import { errorMessage, sendContact } from "../services/veysoApi";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await sendContact(form);
      setSent(true);
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <PageHero eyebrow="Contact us" title="We would love to hear from you" subtitle="Send us a message and the VEYSO team will get back to you." />
      <Section tone="white" narrow>
        <Card>
          {sent ? <Alert severity="success">Thanks. Your message was received.</Alert> : (
            <Box component="form" onSubmit={submit} sx={{ display: "grid", gap: 2 }}>
              {error && <Alert severity="error">{error}</Alert>}
              <TextField label="Name" value={form.name} onChange={set("name")} required inputProps={{ maxLength: 100 }} />
              <TextField label="Email" type="email" value={form.email} onChange={set("email")} required inputProps={{ maxLength: 200 }} />
              <TextField label="How can we help?" value={form.message} onChange={set("message")} multiline minRows={4} required inputProps={{ maxLength: 2000 }} />
              <Button type="submit" variant="contained" size="large" disabled={busy} sx={{ justifySelf: "start" }}>{busy ? "Sending..." : "Send message"}</Button>
            </Box>
          )}
        </Card>
      </Section>
    </>
  );
}
